angular.module('tc.chips', [])
.directive('tcChipsContainer', function(GlobalService) {
	return {
		restrict: 'E',
		transclude: true,
		template: '<ng-transclude></ng-transclude>',
		scope: {
			chipsDataItem: '=tcListboxDataItem',
			listBoxCaption: '@tcListboxCaption',
		},
		link: function(scope) {
			var chipsWatcherUnbind = scope.$watchCollection('chipsDataItem.options', function(newOptions, oldOptions) {
				if (angular.isUndefined(newOptions) || angular.isUndefined(oldOptions)) return;
				var dataItem = scope.chipsDataItem;
				// If option has been added, alert AT users that the selected value has been added to the chips list
				if (newOptions.length > oldOptions.length) {
					var caption = dataItem.options[newOptions.length - 1].caption;
					var alert = caption + ' ' + GlobalService.getGlobalStrings()['XCHIPADD'] + ' ' + scope.listBoxCaption;
					GlobalService.announce(alert, 'alert');
				}
			});
			
			scope.$on('$destroy', function() {
				chipsWatcherUnbind();
			});
		}
	};
});
